var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.344 250.344C95.219 253.469 95.219 258.531 98.344 261.656L250.344 413.656C251.906 415.219 253.938 416 256 416S260.094 415.219 261.656 413.656C264.781 410.531 264.781 405.469 261.656 402.344L123.312 264H440C444.406 264 448 260.422 448 256S444.406 248 440 248H123.312L261.656 109.656C264.781 106.531 264.781 101.469 261.656 98.344S253.469 95.219 250.344 98.344L98.344 250.344ZM0 72V440C0 444.418 3.582 448 8 448S16 444.418 16 440V72C16 67.582 12.418 64 8 64S0 67.582 0 72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftToLine);
export default __webpack_public_path__ + "static/media/arrow-left-to-line.79c9b204b49498b599c590b59ccbcf44.svg";
export { ForwardRef as ReactComponent };